/** ODataGrid satır renkleri — PrimeReact rowClassName ile uygulanır (getRowStyle inline çalışmıyor). */
export const GRID_ROW_CLASS = {
  approved: 'podg-row-approved',
  pending: 'podg-row-pending',
  rejected: 'podg-row-rejected',
  closed: 'podg-row-closed',
  past: 'podg-row-past',
  tagRed: 'podg-row-tag-red',
  tagYellow: 'podg-row-tag-yellow',
  tagGreen: 'podg-row-tag-green',
} as const;

export function getApprovalStatusRowClassName(
  status: string | undefined
): string | undefined {
  if (status === 'Approved') {
    return GRID_ROW_CLASS.approved;
  }

  if (status === 'Pending') {
    return GRID_ROW_CLASS.pending;
  }

  if (status === 'Rejected') {
    return GRID_ROW_CLASS.rejected;
  }

  return undefined;
}

export function getHospitalClosedRowClassName(
  isClosed: boolean | null | undefined
): string | undefined {
  if (isClosed === true) {
    return GRID_ROW_CLASS.closed;
  }

  return undefined;
}

export function getHospitalRecordColorRowClassName(
  color: string | null | undefined
): string | undefined {
  if (color === 'red') {
    return GRID_ROW_CLASS.tagRed;
  }

  if (color === 'yellow') {
    return GRID_ROW_CLASS.tagYellow;
  }

  if (color === 'green') {
    return GRID_ROW_CLASS.tagGreen;
  }

  return undefined;
}

export function getPastAppointmentRowClassName(
  appointmentDate: string | Date | null | undefined
): string | undefined {
  if (!appointmentDate) {
    return undefined;
  }

  const date = new Date(appointmentDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  if (date < today) {
    return GRID_ROW_CLASS.past;
  }

  return undefined;
}
